export default __webpack_public_path__ + "static/media/our-team-3.9db4b8c9.jpg";